(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Hues/Breadcrumbs/_breadcrumbs.tpl.html',
    '<div class="filter-current"><h3><span ng-repeat="crumb in breadcrumbs.breadcrumbs" ng-if="crumb"><strong class="title {{breadcrumbs.current_color}}">{{crumb}}</strong></span></h3></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Hues/Single/_single-hue.tpl.html',
    '<div class="open-hue"><div class="hue-content"><div class="pallete" ng-style="{\'background-color\': hue.hue_hexadecimal ? \'#\'+hue.hue_hexadecimal : \'\', \'background-image\': hue.texture ? \'url(\'+hue.texture+\')\' : hues.texture ? \'url(\'+hues.texture+\')\' : hue.hue_img ? \'url(\'+hue.hue_img+\')\' : \'\'}"></div><div class="info"><span class="close-hue"><a ng-if="hue.redirect" class="back" ng-href="{{hue.redirect}}">חזרה</a> <i class="close na-close"></i></span><div class="details"><h1 class="ng-binding">{{hue.hue_code}}</h1><h2 class="ng-binding">{{hue.name}}</h2><span class="ng-binding">שייך למניפת: {{hue.fan}}</span></div><div class="actions"><ul class="wishlist"><li><i class="na-drop-small" data-wishlist="samples" data-id="{{hue.ID}}" data-fan="{{hue.neutral_fan_id ? hue.neutral_fan_id : hues.neutral_fan_id ? hues.neutral_fan_id : null}}"></i> הוספה לדוגמאות</li><li><i class="na-heart-small" data-wishlist="hues" data-id="{{hue.ID}}"></i> הוספה למועדפים</li></ul><ul class="mini"><li><a ng-href="{{hue.print_url}}" target="_blank"><i class="na-print"></i><span>הדפסה</span></a></li><li><a ng-href="mailto:?Subject={{hue.name}}&amp;body={{hue.mail_url}}"><i class="na-mail"></i><span>שליחה במייל</span></a></li><li><i class="na-share" data-share="hue" data-slug="{{hue.slug}}" data-fan="{{hue.neutral_fan_id ? hue.neutral_fan_id : hues.neutral_fan_id ? hues.neutral_fan_id : null}}"></i><span>שיתוף</span></li></ul></div><div class="hues-btn"><div ng-if="!hue.nextBtn"><button ng-click="hue.nextBtn = true" class="go-next-btn button">שמירת גוון ומוצרים מתאימים</button></div><div ng-if="hue.nextBtn"><p>את הגוון הנבחר ניתן לשמור במועדפים למועד מאוחר יותר, או לבחור לו מוצר מתאים ולקנות ברגע זה</p><button class="button transparent" data-wishlist="hues" data-id="{{hue.ID}}">הוספה למועדפים</button> <a href="{{hues.CATALOG_URL + \'/\' + ( hue.hue_code | spaceless )}}" class="button" onclick="GA.send(\'Shades Fan\', \'Suitable products\');">למוצרים מתאימים</a></div></div></div></div></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Filters/Categories/Templates/_category.tpl.html',
    '<a ui-state="category_state.state" ui-state-params="{category_slug: category.slug}" class="swiper-slide" ui-sref-active="current" ui-state-opts="{ reload: true }"><i class="{{category.class}}"></i> <span>{{category.name}}</span></a>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Filters/Categories/Views/_categories.tpl.html',
    '<div id="type" class="filter-strip"><div class="swiper-outer"><div class="swiper-container"><div class="swiper-wrapper"><category ng-repeat="category in categories.categories" swiper></category></div></div></div><div class="swiper-button-next"></div><div class="swiper-button-prev"></div></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Filters/Color-Fans/Templates/_color-fan.tpl.html',
    '<li class="swiper-slide" ui-sref-active="current"><a ui-sref="^.colors({color_fan_slug: fan.slug})" ui-sref-opt="{ reload: true }" onclick="GA.send(\'Shades Fan\', \'Filter by Fan\');"><span title="{{fan.name}}">{{fan.name}}</span></a></li>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Filters/Color-Fans/Views/_color-fans.tpl.html',
    '<div id="fan" class="filter-strip {{filters.current_color}}"><div><span>הצגת מניפה:</span><div class="swiper-outer"><div class="swiper-container"><ul class="swiper-wrapper"><li class="all swiper-slide" ui-sref-active="current"><a ui-sref="{color_fan_slug: null}" onclick="GA.send(\'Shades Fan\', \'Filter by Fan\');"><span title="כל מניפות הגוונים">כל מניפות הגוונים</span></a></li><color-fan ng-repeat="fan in color_fans.color_fans" swiper></color-fan></ul></div><div class="swiper-button-next"></div><div class="swiper-button-prev"></div></div></div></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Filters/Effect-Fans/Templates/_effect-fan.tpl.html',
    '<a ui-state="effect_fan_state.state" ui-state-params="{effect_fan_slug: fan.slug}" ui-sref-active="current" ui-state-opts="{ reload: true }" class="swiper-slide"><i style="background-image: url({{fan.img}})"></i> <span title="{{fan.name}}">{{fan.name}}</span></a>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Filters/Effect-Fans/Views/_effect-fans.tpl.html',
    '<div id="effect" class="filter-strip {{filters.current_color}}"><div class="swiper-outer"><div class="swiper-container"><div class="swiper-wrapper"><a ui-sref="main.categories.families.effects({effect_fan_slug: null})" ui-sref-opts="{ reload: true }" class="swiper-slide all" ui-sref-active="current"><i class="na-categories-all"></i> <span>כל סוגי האפקטים</span></a><effect-fan ng-repeat="fan in effect_fans.effect_fans" swiper></effect-fan></div></div></div><div class="swiper-button-next"></div><div class="swiper-button-prev"></div></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Filters/Families/Templates/_family.tpl.html',
    '<a ui-sref="{family_slug: family.slug}" ui-sref-active="current" class="swiper-slide" onclick="GA.send(\'Shades Fan\', \'Filter by Shade\');"><i class="{{family.slug}}"></i> <span>{{family.name}}</span></a>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Filters/Families/Views/_families.tpl.html',
    '<div id="color" class="filter-strip {{filters.current_color}}"><div class="swiper-outer"><div class="swiper-container"><div class="swiper-wrapper"><a ui-sref="{family_slug: null}" class="all colorful swiper-slide" ui-sref-active="current" onclick="GA.send(\'Shades Fan\', \'Filter by Shade\');"><i class="na-categories-all"></i> <span>כל הגוונים</span></a><family ng-repeat="family in families.families" swiper></family></div></div></div><div class="swiper-button-next"></div><div class="swiper-button-prev"></div></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Filters/Main/Views/_Filters.tpl.html',
    '<div id="filters" class="no-underline" ng-class="{\'open\': filters.filterOn}"><div ui-view="categories" class="filter-strip"></div><div ui-view="inner-filters" is-resolve style="min-height: 100px"></div></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Filters/Main/Views/_inner-filters.tpl.html',
    '<div ui-view="families" ng-class="{\'filter-strip\': families.families.length}"></div><div ui-view="effect" ng-class="{\'filter-strip\': effect_fans.effect_fans.length}"></div><div ui-view="color-fans" ng-class="{\'filter-strip\': color_fans.color_fans.length}"></div><div ui-view="sub-categories"></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Filters/Mobile-Filters/Views/_mobile-filter.tpl.html',
    '<nav id="filter-categories" class="filter-strip" swiper><div class="swiper-outer"><div class="swiper-container"><ul class="swiper-wrapper"><li class="swiper-slide"><a ng-click="mobile.toggleFilters(\'filterOn\')" ng-class="{\'current\' : mobile.filterOn}" title="סינון תוצאות">סינון תוצאות</a></li><li class="swiper-slide"><a ng-click="mobile.toggleFilters(\'searchOn\')" ng-class="{\'current\' : mobile.searchOn}" title="חיפוש">חיפוש</a></li></ul></div></div></nav>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Filters/Search/Views/_Search.tpl.html',
    '<div id="search-filter" class="filter-strip" ng-class="{\'open\': search.searchOn}"><div class="search-area"><autocomplete on-enter="search.getResults" on-type="search.searchHues" on-select="search.getSingleResult" ng-model="yourchoice" data="options" attr-placeholder="חיפוש לפי שם קוד/ גוון"></autocomplete><button><i class="na-search"></i> <span>חפש</span></button></div></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Filters/Sub-Categories/Views/_sub-categories.html',
    '<div class="wood-filters" ng-class="{ \'loading\': subcategories.handler.loading }"><select scroll-to class="black" ng-repeat="subcategory in subcategories.handler.subcategories" ng-change="subcategories.handler.selectSubcat( this )" ng-model="option" ng-options="option.term_id as option.name for option in subcategory"></select></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Hues/Main/Templates/_hue.tpl.html',
    '<div class="fan archive item-wrapper" ui-sref-active="chosen"><div class="hue"><a ui-sref=".hue({hue_code: ( hue.hue_code | spaceless )})" class="the-hue" ng-style="{\'background-color\': hue.hue_hexadecimal ? \'#\'+hue.hue_hexadecimal : \'\', \'background-image\': hue.texture ? \'url(\' + ( hue.texture | thumb )+ \')\' : hues.texture ? \'url(\' + ( hues.texture | thumb ) + \')\' : hue.hue_img ? \'url(\' + ( hue.hue_img | thumb ) + \')\' : \'\'}" onclick="GA.send(\'Shades Fan\', \'Choose Shade\');"><span>{{hue.hue_code}}</span></a><div class="info"><div class="wishlist"><i class="na-heart-small" data-wishlist="hues" data-id="{{hue.ID}}"></i> <i class="na-drop-small" data-wishlist="samples" data-id="{{hue.ID}}" data-fan="{{hue.neutral_fan_id ? hue.neutral_fan_id : hues.neutral_fan_id ? hues.neutral_fan_id : null}}"></i></div><p><a ui-sref=".hue({hue_code: ( hue.hue_code | spaceless )})" title="{{hue.name}}">{{hue.name}}</a> <span>מניפת {{hue.fan}}</span></p></div></div><single-hue ng-if="hues.single === hue.hue_code"></single-hue></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Hues/Main/Views/_hues.tpl.html',
    '<div class="the-fans" ng-class="{loading: hues.loading}" infinite-scroll="hues.loadMorehues()" infinite-scroll-disabled="hues.loading || hues.busy" infinite-scroll-use-document-bottom="true"><hue ng-repeat="hue in hues.hues"></hue><div ng-if="hues.busy" class="load-more loading" style="height: 100px; width: 100%"></div><p ng-if="hues.not_found">לא נמצאו גוונים המתאימים לשילוב שהוזן</p></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Hues/Main/Views/_the-fans.tpl.html',
    '<div class="the-fans" ng-hide="fans.hide"><div class="container"><div class="save-and-current"><div ui-view="breadcrumbs"></div><div ui-view="save-fan"></div></div><div ui-view="hues"></div></div></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Hues/Save-Fan/Views/_save-fan.tpl.html',
    '<div class="save-fan" onclick="$(this).toggleClass(\'open\')" ng-if="save.files && save.hasHues"><i class="na-save"></i> <span>שמירת גווים ממניפה זאת</span><div class="tooltip right"><ul><li ng-repeat="file in save.files"><a href="{{file.file_url}}" download>{{file.format}}</a></li></ul></div></div>');
}]);
})();
